export const ROUTE = {
  login: "/login",
  dashboard: "dashboard",
  member: "member",
  transaction: "transaction",
  topup: "topup",
  withdraw: "withdraw",
  bet: "bet",
  bet_option: "bet_option",
  staff: "staff",
  setting: "setting",
  chat: "chat",
  country: "country",
  room: "room",
  admin: "admin",
  branch: "branch",
  bot: "bot",
  digitalWallet: "digital-wallet",
  deposit: "deposit",
};
